import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	"data-testid": "check-circle-icon",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 9.25,
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "m8 12.25 2.75 2.75L16.5 9.25",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCheckCircle;
